import React from 'react';
import { ModalContent, ModalHeader, Typography } from 'common/components';

export const Price = () => (
  <>
    <ModalHeader title="Приятные цены" />
    <ModalContent variant="simple">
      <Typography adaptive={false} variant="m" size="body_long">
        Благодаря оптимальным решениям и&nbsp;прямым поставкам, вы&nbsp;получаете
        стильную ванную на&nbsp;заказ без переплат.
      </Typography>
      <Typography adaptive={false} variant="m" size="body_long">
        Качество остаётся высоким, а&nbsp;подход&nbsp;&mdash; индивидуальным.
      </Typography>
      <Typography adaptive={false} variant="m" size="body_long">
        Цены на&nbsp;услуги тоже остаются выгодными&nbsp;&mdash; от&nbsp;замера и&nbsp;укладки
        плитки до&nbsp;монтажа и&nbsp;установки техники.
      </Typography>
    </ModalContent>
  </>
);
